// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'fullpage.js/dist/fullpage.min.css'
import 'swiper/dist/css/swiper.css'
import './assets/less/home.less'
import './assets/less/iconfont.css'
// 全屏滚动 vue-fullpage.js
import VueFullpage from 'vue-fullpage.js'
import 'fullpage.js/vendors/scrolloverflow'
import AOS from 'aos'
import '../node_modules/aos/dist/aos.css'
import axios from 'axios'

import animated from 'animate.css'
Vue.prototype.axios = axios
// 省略部分代码
Vue.use(animated)
Vue.use(AOS)

Vue.config.productionTip = false
Vue.use(ViewUI)
Vue.use(VueFullpage)
Vue.use(VueAwesomeSwiper /* { default global options } */)
/* eslint-disable no-new */
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  if (/Mobi/i.test(navigator.userAgent)) {
    console.log(window.location.origin + '/h5/index.html#/' + to.name);
    console.log(to);
    const queryArr = to.fullPath.split("?");
    if (queryArr.length > 1) {
      window.location.href = window.location.origin + '/h5/index.html#/' + to.name + "?" + queryArr[1]
    } else {
      window.location.href = window.location.origin + '/h5/index.html#/' + to.name
    }
  } else {

  }
  next()
})
const hiet = {
  mounted() {
    window.addEventListener('beforeunload', e => {
      window.localStorage.removeItem('page')
    })
  }
}
// Vue.mixin(hiet)
new Vue({
  el: '#app',
  mixins: [hiet],
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js